/**
 * Environment detection utility.
 *
 * Centraliza la detección del entorno para que sea fácilmente
 * mockeable en tests unitarios con vi.mock().
 */

/**
 * Verdadero cuando el frontend se ejecuta en modo desarrollo (Vite, vitest).
 * En PRODUCCIÓN (build con vite build o vitest con mock), es false.
 */
export const IS_DEV: boolean = import.meta.env.DEV;

/**
 * Indica si la web y el registro público están activos (WEB_ACTIVE).
 * ✅ PRODUCCIÓN: Siempre retorna true (la web está operativa desde oct-2026)
 */
export const isWebActive = (): boolean => {
  // ✅ Web operativa en producción (22 oct 2026+)
  return true;
};

/**
 * Indica si se debe omitir la verificación de identidad con Stripe.
 * Útil para pruebas en producción o desarrollo donde no se quiere/puede
 * completar el flujo KYC real de Stripe.
 */
export const isStripeIdentityBypassed = (): boolean => {
  // Verificación activa por defecto en desarrollo y producción.
  // Permite forzar bypass únicamente si se define explícitamente VITE_BYPASS_STRIPE_IDENTITY=true.
  const envVal = (
    import.meta.env.VITE_BYPASS_STRIPE_IDENTITY ??
    "false"
  ).toString().toLowerCase().trim();

  return envVal === "true";
};


